import React, { useState } from "react";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import PropTypes from "prop-types";
import Switch from "components/Switch";
import { setWorkspaceReservedLicenses } from "slices/systemAdmin/actions/systemAdmin";

const ReserveLicensesModal = ({
  workspaceName,
  workspaceId,
  licensedUsers,
  reservedLicenses,
}) => {
  const dispatch = useDispatch();
  const [currentReservedLicenses, setCurrentReservedLicenses] =
    useState(reservedLicenses);
  const [switchActive, setSwitchActive] = useState(reservedLicenses !== null);

  const handleChange = () => {
    setSwitchActive(!switchActive);
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.WORKSPACE_RESERVED_LICENSES));
  };

  const handleSave = () => {
    const newLimit = switchActive ? Number(currentReservedLicenses) : -1;
    dispatch(
      setWorkspaceReservedLicenses(
        workspaceId,
        newLimit,
        licensedUsers > currentReservedLicenses
      )
    );
  };

  const isDisabled = () => currentReservedLicenses <= 0;

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter" && !isDisabled()) {
      handleSave();
    }
  };

  const modalBody = () => (
    <div
      className="reserved__licenses__modal__options"
      data-testid="reserve-license-body"
    >
      <div className="reserved__licenses__modal__options__licensed__users">
        Licensed Users <span>{licensedUsers}</span>
      </div>
      <div className="reserved__licenses__modal__options__user__count">
        Reserve Licenses
        <Switch
          handleChange={handleChange}
          currentSwitchState={switchActive}
          id="switch-reserve-license-modal"
        />
      </div>
      <div className="reserved__licenses__modal__options__count">
        Number of Licenses Reserved
        <span>
          <input
            type="text"
            value={currentReservedLicenses}
            disabled={!switchActive}
            onChange={(e) => {
              setCurrentReservedLicenses(e.target.value);
            }}
            className={
              currentReservedLicenses > 0 || currentReservedLicenses === null
                ? ""
                : "error"
            }
            data-testid="licenses-reserved"
          />
        </span>
      </div>
    </div>
  );

  return (
    <Modal
      data-testid="reserveLicensesWorkspaceModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
      onKeyDown={onEnterKeyDown}
    >
      <Modal.Header closeButton>
        <b className="reserved__licenses__modal__header">
          Reserve Number of Licenses for {workspaceName}
        </b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <Button
          dataTestId="saveButton"
          variant={buttonVariants.primary}
          onClick={handleSave}
          disabled={isDisabled()}
          content="Save"
        />
        <Button
          dataTestId="cancelButton"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ReserveLicensesModal;

ReserveLicensesModal.propTypes = {
  workspaceName: PropTypes.string.isRequired,
  workspaceId: PropTypes.number.isRequired,
  licensedUsers: PropTypes.number.isRequired,
  reservedLicenses: PropTypes.number,
};
